import { CustomField, CustomFieldAPI, CustomFieldType, CustomFieldUpdateAPI } from './custom-field.type';

export const mapNewCustomFieldFromModeltoApi = (customField: CustomField): CustomFieldAPI => ({
    name: customField.name,
    order: customField.order,
    type: customField.type ?? CUSTOM_FIELD_TYPE_OPTIONS.OPERATORS,
});

export const mapUpdateCustomFieldFromModeltoApi = (customField: CustomField): CustomFieldUpdateAPI => ({
    name: customField.name,
});

export const mapCustomFieldFromModeltoApi = (customField: CustomField): CustomFieldAPI => ({
    id: customField.id,
    name: customField.name,
    order: customField.order,
    type: customField.type ?? CUSTOM_FIELD_TYPE_OPTIONS.OPERATORS,
});

export const mapCustomFieldFromApiToModel = (customField: CustomFieldAPI): CustomField => ({
    id: customField.id,
    name: customField.name,
    order: customField.order,
    type: customField.type,
});

export const CUSTOM_FIELD_TYPE_OPTIONS: Record<CustomFieldType, CustomFieldType> = {
    OPERATORS: 'OPERATORS',
    DEVICES: 'DEVICES',
};
